import React, { createContext } from "react";

export const DashboardCardExtraContext = createContext<{
    setExtra: (node: React.ReactNode | null) => void;
    setTitleSuffix?: (node: React.ReactNode | null) => void;
} | null>(null);
